/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Enforcement_AuthorityInputs */

const en_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market Surveillance for Accessibility Requirements (MLBF AoeR)`)
};

const de_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktüberwachung Barrierefreiheitsanforderungen (MLBF AöR)`)
};

const fr_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surveillance du marche pour les exigences d'accessibilite (MLBF AoeR)`)
};

const es_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vigilancia del mercado para requisitos de accesibilidad (MLBF AoeR)`)
};

const it_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorveglianza del mercato per i requisiti di accessibilita (MLBF AoeR)`)
};

const nl_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markttoezicht voor toegankelijkheidseisen (MLBF AoeR)`)
};

const pl_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadzor rynku ds. wymagan dostepnosci (MLBF AoeR)`)
};

const fi_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutettavuusvaatimusten markkinavalvonta (MLBF AoeR)`)
};

const da_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markedsovervagning for tilgaengelighedskrav (MLBF AoeR)`)
};

const sv_a11y_statement_enforcement_authority = /** @type {(inputs: A11y_Statement_Enforcement_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marknadstillsyn for tillganglighetskrav (MLBF AoeR)`)
};

/**
* | output |
* | --- |
* | "Market Surveillance for Accessibility Requirements (MLBF AoeR)" |
*
* @param {A11y_Statement_Enforcement_AuthorityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_enforcement_authority = /** @type {((inputs?: A11y_Statement_Enforcement_AuthorityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Enforcement_AuthorityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_enforcement_authority(inputs)
	if (locale === "fr") return fr_a11y_statement_enforcement_authority(inputs)
	if (locale === "es") return es_a11y_statement_enforcement_authority(inputs)
	if (locale === "it") return it_a11y_statement_enforcement_authority(inputs)
	if (locale === "nl") return nl_a11y_statement_enforcement_authority(inputs)
	if (locale === "pl") return pl_a11y_statement_enforcement_authority(inputs)
	if (locale === "fi") return fi_a11y_statement_enforcement_authority(inputs)
	if (locale === "da") return da_a11y_statement_enforcement_authority(inputs)
	if (locale === "sv") return sv_a11y_statement_enforcement_authority(inputs)
	return en_a11y_statement_enforcement_authority(inputs)
});